var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0774 27.9998H5.76968V16.9228H4.14045C3.08999 16.9228 2.59983 15.613 3.39091 14.9216L14.1983 4.68746C15.1657 3.77085 16.6804 3.77085 17.6478 4.68746L28.4543 14.9216C29.2463 15.6121 28.7561 16.9228 27.7048 16.9228H26.0774V27.9998Z",
    stroke: "#47127D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.619 27.9964H12.2344V22.4579C12.2344 20.4189 13.8876 18.7656 15.9267 18.7656C17.9658 18.7656 19.619 20.4189 19.619 22.4579V27.9964Z",
    stroke: "#47127D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeV);
export default __webpack_public_path__ + "static/media/Home_V.26546c87fbcc8e29f51c4838038ceb79.svg";
export { ForwardRef as ReactComponent };